import type { FaireProductEntity } from "../../entity_types/product";

export const p_knwzzhk4mw: FaireProductEntity = {
  token: "p_knwzzhk4mw",
  type: "product",
  name: "Avocado Morning Tea Towel",
  brandName: "RHB HAWAII",
  imageUrl:
    "https://cdn.faire.com/fastly/4cb29f4829dad7b1e12414100ad1934f6f77f5810c011e25c3ff32cb413def6e.jpeg",
  priceDollars: 8.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/26bd1bd8a2ba7244a1bdf90c49a52b22f19d8e307d7aec153ef7883f49001e50.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
